import { Redirect, Route } from 'react-router-dom';
import React from 'react';

/**
 * Private Route Component.  Redirects if the user is not logged in
 *
 * @param {Object} props All the properties passed to the React Component.
 * @returns {Element} Stateless functional React component.
 */
const PrivateRouteComponent = ({
  component: Component,
  isLoggedIn = false,
  match: { url },
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) =>
      isLoggedIn ? <Component {...props} /> : <Redirect to={`${url}/login`} />
    }
  />
);

export default PrivateRouteComponent;



// WEBPACK FOOTER //
// ./src/components/common/PrivateRoute/PrivateRouteComponent.js